import React, { Component } from "react";

export class PQR extends Component {

    constructor(props) {
        super(props);

        this.state = {
            model: {}
        }
    }

    async save() {
        this.setState({ isPost: true, loading: true });

        const request = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(this.state.model)
        }

        let response = await fetch(`PQR/Insert`, request);
        switch (response.status) {
            case 200:
                alert(`Su ${this.state.model.type} ha sido enviada con éxito.`);
                this.setState({ model: {} })
                break;
            default:
                alert(`La información no se proceso con éxito, verifique los datos e inténtelo de nuevo.`);
        }
        this.setState({ loading: false })
    }

    render() {
        return (
            <div id="formPqr">
                <div className="alert info text-center">Formulario para queja, petición o reclamo</div>

                <div className="form-group">
                    <label>* Tipo de contacto</label>
                    <select className="form-control" defaultValue={this.state.model.type} onChange={(e) => { this.state.model.type = e.currentTarget.value; }}>
                        <option value="">Seleccione</option>
                        <option value="Felicitación">Felicitación</option>
                        <option value="Queja">Queja</option>
                        <option value="Petición">Petición</option>
                        <option value="Reclamo">Reclamo</option>
                    </select>
                    {this.state.isPost && !Boolean(this.state.model.type) ? <span className="error required">Campo requerido</span> : null}
                </div>
                <div className="form-group">
                    <label>* Nombre</label>
                    <input type="text" className="form-control" defaultValue={this.state.model.name} onChange={(e) => { this.state.model.name = e.currentTarget.value; }} />
                    {this.state.isPost && !Boolean(this.state.model.name) ? <span className="error required">Campo requerido</span> : null}
                </div>
                <div className="form-group">
                    <label>* Correo electrónico</label>
                    <input type="text" className="form-control" defaultValue={this.state.model.email} onChange={(e) => {
                        if (String(e.currentTarget.value).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                            this.state.model.email = e.currentTarget.value;
                        } else {
                            this.state.model.email = '';
                        }
                    }} />
                    {this.state.isPost && !Boolean(this.state.model.email) ? <span className="error required">Formato incorrecto asegurese de ingresar un correo válido</span> : null}
                </div>
                <div className="form-group">
                    <label>* Celular</label>
                    <input type="text" className="form-control" defaultValue={this.state.model.cell} onChange={(e) => { this.state.model.cell = e.currentTarget.value; }} />
                    {this.state.isPost && !Boolean(this.state.model.cell) ? <span className="error required">Campo requerido</span> : null}
                </div>
                <div className="form-group">
                    <label>* Mensaje</label>
                    <textarea type="text" className="form-control" defaultValue={this.state.model.message} onChange={(e) => { this.state.model.message = e.currentTarget.value; }}></textarea>
                    {this.state.isPost && !Boolean(this.state.model.message) ? <span className="error required">Campo requerido</span> : null}
                </div>
                <div className="form-group">
                    <input type="button" className="btn btn-primary" value={this.state.loading ? 'Procesando...' : 'Guardar'} disabled={this.state.loading} onClick={() => { this.save() }} />
                </div>
            </div>
        )
    }
}